
<header>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
          <a [routerLink]="['']" routerLinkActive="router-link-active" class="navbar-item">
            Question Data
          </a>
          <a [routerLink]="['/question-text']" routerLinkActive="router-link-active" class="navbar-item">
            Question Text and Rubric Description
          </a>

        </div>
      </div>
    </div>
  </nav>
</header>
